<template>
  <div class="index-page">
    <div class="banner-container">
      <div class="haeder-container">
        <Header></Header>
        <Nav></Nav>
      </div>
      <div class="swiper-container">
        <swiper class="swiper" :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
          <!-- slides -->
          <swiper-slide class="swiper-item swiper-item1">
            <div class="swiper-item-container">
              <!-- <div class="swiper-item-content-container">
                <p class="swiper-item-title">百倍云-工业传感器智能化最大综合平台</p>
                <p class="swiper-item-sub-title">150+设备种类接入能力领跑业界</p>
                <div class="swiper-item-operation-container">
                  <a href="javascript:;" class="swiper-item-see-more" @click="jump( 'bby_iot_platform' )">查看更多</a>
                  <img src="../../assets/img/index/bofang.png" alt="" class="swiper-item-play-btn">
                </div>
              </div> -->
              <!-- 底部的附加内容 -->
              <div class="swiper-item-additional-content-container">
                <ul class="controls-list-btn-container">
                  <li class="controls-item-btn-container" @click="slideTo( 1 )">
                    <img src="../../assets/img/index/swiper_controls_true.png" alt="">
                  </li>
                  <li class="controls-item-btn-container" @click="slideTo( 2 )">
                    <img src="../../assets/img/index/swiper_controls_false.png" alt="">
                  </li>
                  <li class="controls-item-btn-container" @click="slideTo( 3 )">
                    <img src="../../assets/img/index/swiper_controls_false.png" alt="">
                  </li>
                  <li class="controls-item-btn-container">
                    <p class="additional-content">加速推进现代化乡村数字化建设是我们的愿景目标</p>
                  </li>
                </ul>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper-item swiper-item2">
            <div class="swiper-item-container">
              <!-- <div class="swiper-item-content-container">
                <p class="swiper-item-title">百倍云-工业互联网解决方案专家</p>
                <p class="swiper-item-sub-title">500+设备案例提供领跑业界</p>
                <div class="swiper-item-operation-container">
                  <a href="javascript:;" class="swiper-item-see-more" @click="jump( 'jijiagong' )">查看更多</a>
                  <img src="../../assets/img/index/bofang.png" alt="" class="swiper-item-play-btn">
                </div>
              </div> -->
              <!-- 底部的附加内容 -->
              <div class="swiper-item-additional-content-container">
                <ul class="controls-list-btn-container">
                  <li class="controls-item-btn-container" @click="slideTo( 1 )">
                    <img src="../../assets/img/index/swiper_controls_false.png" alt="">
                  </li>
                  <li class="controls-item-btn-container" @click="slideTo( 2 )">
                    <img src="../../assets/img/index/swiper_controls_true.png" alt="">
                  </li>
                  <li class="controls-item-btn-container" @click="slideTo( 3 )">
                    <img src="../../assets/img/index/swiper_controls_false.png" alt="">
                  </li>
                  <li class="controls-item-btn-container">
                    <p class="additional-content">加速推进现代化乡村数字化建设是我们的愿景目标</p>
                  </li>
                </ul>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper-item swiper-item3">
            <div class="swiper-item-container">
              <!-- <div class="swiper-item-content-container">
                <p class="swiper-item-title">百倍云-工业互联网解决方案专家</p>
                <p class="swiper-item-sub-title">500+设备案例提供领跑业界</p>
                <div class="swiper-item-operation-container">
                  <a href="javascript:;" class="swiper-item-see-more" @click="jump( 'industrial_interconnection2' )">查看更多</a>
                  <img src="../../assets/img/index/bofang.png" alt="" class="swiper-item-play-btn">
                </div>
              </div> -->
              <!-- 底部的附加内容 -->
              <div class="swiper-item-additional-content-container">
                <ul class="controls-list-btn-container">
                  <li class="controls-item-btn-container" @click="slideTo( 1 )">
                    <img src="../../assets/img/index/swiper_controls_false.png" alt="">
                  </li>
                  <li class="controls-item-btn-container" @click="slideTo( 2 )">
                    <img src="../../assets/img/index/swiper_controls_false.png" alt="">
                  </li>
                  <li class="controls-item-btn-container" @click="slideTo( 3 )">
                    <img src="../../assets/img/index/swiper_controls_true.png" alt="">
                  </li>
                  <li class="controls-item-btn-container">
                    <p class="additional-content">加速推进现代化乡村数字化建设是我们的愿景目标</p>
                  </li>
                </ul>
              </div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
    </div>


    <!-- 解决方案 -->
    <div class="solution-modular-container">
      <div class="center-container" style="padding-top:80px;padding-bottom:80px">
        <div class="solution-left-container">
          <div class="solution-info-container2" >
            <p class="solution-first-title">解决方案</p>
            <p class="solution-sub-title" style="font-size: 18px;color: #ffffff;line-height: 40px;width: 320px;margin:0;margin-top:20px">智能互联 数字化乡村综合服务方案</p>
            <p class="solution-sub-title" style="font-size: 18px;color: #ffffff;line-height: 40px;width: 320px;margin:0;margin-bottom:20px">既是乡村振兴的战略方向，也是建设数字中国的重要内容</p>        
            <a href="javascript:;" class="see-more-btn" @click="jump( 'shuzixiangcun' )">查看更多</a>
          </div>
          <div class="solution-item-container2" @click="jump( 'allShareAac' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr17.png" alt="" class="solution-item-logo solution4" style="">
                <span class="solution-item-name">共享田园</span>
              </div>
              <p class="solution-item-description">在线认养农田、菜地、果园、茶园渔场等地块远程查看管理，现场农事活动，远离城市喧嚣亲身体验耕种采摘乐趣，乡土特产商城及田园种植互动等功能，打造田园共享经济，吸引游客旅游，促销乡村特产。</p>
            </div>
           <div class="solution-item-container2" @click="jump( 'intelligentAgriculture' )">
            <div class="solution-item-title">
              <img src="../../assets/img/index/solutionr13.png" alt="" class="solution-item-logo solution1" style="">
              <span class="solution-item-name">大田农业物联网</span>
            </div>
            <p class="solution-item-description">由安置在大田中的土壤温湿度传感器、土壤养分采集仪和气象站等设备采集大田土壤和气象数据，经由智能网关传送至服务器。服务器对大田环境数据进行综合分析，形成决策指令</p>
          </div>
          
           <div class="solution-item-container2" @click="jump( 'fishAndVeg' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr22.png" alt="" class="solution-item-logo solution4" style="">
                <span class="solution-item-name">鱼菜共生</span>
              </div>
              <p class="solution-item-description">鱼菜共生将水产养殖与水耕栽培这两种原本完全不同的农耕技术，通过巧妙的生态设计，达到科学的协同共生，从而实现养鱼不换水而无水质忧患，种菜不施肥而正常成长的生态共生效应。</p>
            </div>
         
          
          <!-- <div style="text-align:center;height:330px" class="solution-item-container2" @click="jump( 'shuzixiangcun' )">
              <img src="../../assets/img/index/solutionr6.png" alt="" class="bt-img" style="">
            <p class="bt-title">数字乡村</p>
            <p class="bt-p">集公共卫生安全、环境监测、垃圾分类、党建于一体的街道、乡镇综合解决方案，专业研究数字化乡镇综合服务平台</p>
          </div> -->
        </div>
        <div class="solution-right-container">
          <div>
            <div class="solution-item-container2" @click="jump( 'shuzixiangcun' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr1.png" alt="" class="solution-item-logo solution2">
                <span class="solution-item-name">数字乡村</span>
              </div>
              <p class="solution-item-description">集公共卫生安全、环境监测、垃圾分类于一体的街道、乡镇综合解决方案，专业研究数字化乡镇综合服务平台。</p>
            </div>
            <div class="solution-item-container2" @click="jump( 'newPeople' )" >
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr16.png" alt="" class="solution-item-logo solution2">
                <span class="solution-item-name">新农人</span>
              </div>
              <p class="solution-item-description">农村专业技能培训，人才鉴定，农企招工，农民工找工作专业平台，乡村人才引进线上渠道推进乡村人才发展，助力乡村振兴。</p>
            </div>
            
            <!--  -->
          </div>
          <div>
             
            <div class="solution-item-container2" @click="jump( 'online_retailers' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr15.png" alt="" class="solution-item-logo solution5">
                <span class="solution-item-name">农村电商邻里拼</span>
              </div>
              <p class="solution-item-description">特色农村电商服务平台，着力于以贴近农户的各县域、村级服务站等,完美打通当下农村的信息、物流等壁垒,有效解决渠道少,销售难,效率低等难题。</p>
            </div>
            <div class="solution-item-container2" @click="jump( 'intelligentAgricultureall' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr3.png" alt="" class="solution-item-logo solution1" style="">
                <span class="solution-item-name">大棚农业物联网</span>
              </div>
              <p class="solution-item-description">通过气象、土壤、水质等传感器数据采集，植物生长模型分析，决策分析，自动控制水肥一体化设备，大棚遮阳和水泵等设施，实现大棚精细化管理。</p>
            </div>

            <!--  -->
            <!--  -->
          </div>
          <div>
            <div class="solution-item-container2" @click="jump( 'farmingandagriculturalmaterials' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr14.png" alt="" class="solution-item-logo solution4" style="">
                <span class="solution-item-name">农事农资</span>
              </div>
              <p class="solution-item-description">系统通过记录基地地块生产单元、农资购买和使用档案、基地年度生产档案、详细农事操作人工作业计划、资源适用记录、成本核算等信息，实现对农业生产全过程的信息采集和资源管理。</p>
            </div>
            
            <div class="solution-item-container2" @click="jump( 'digitalFishery' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr2.png" alt="" class="solution-item-logo solution3">
                <span class="solution-item-name">数字渔场</span>
              </div>
              <p class="solution-item-description">提供尾水治理、渔场物联网监测、养殖基地管理，提供养殖基地管理、养殖物资采购、生产指导服务、物联网设备管理、人工智能体验为一体的数字渔业平台。</p>
            </div>
            
            <!-- <div style="text-align:center;height:330px" class="solution-item-container2" @click="jump( 'shuzixiangcun' )">
              <img src="../../assets/img/index/solutionr7.png" alt="" class="bt-img" style="">
            <p class="bt-title">农村电商邻里拼</p>
            <p class="bt-p">拼团买菜更多实惠，贴近乡村生活的买菜小程序</p>
          </div>
            <div style="text-align:center;height:330px" class="solution-item-container2" @click="jump( 'digitalFishery' )">
              <img src="../../assets/img/index/solutionr8.png" alt="" class="bt-img" style="">
            <p class="bt-title">数字渔场</p>
            <p class="bt-p">提供养殖基地管理、养殖物资采购、物联网设备管理</p>
          </div> -->
          </div>
          <div>
             <div class="solution-item-container2" @click="jump( 'nongyesuyuan' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr4.png" alt="" class="solution-item-logo solution4" style="">
                <span class="solution-item-name">农产品溯源</span>
              </div>
              <p class="solution-item-description">采用农业物联网技术、区块链技术，对农产品的产地环境、农业投入品、农事生产过程、质量检测、加工储运等质量安全关键环节进行数字化管理，实现农产品的全程可追溯。</p>
            </div>
            <div class="solution-item-container2" @click="jump( 'pestMonitoring' )">
              <div class="solution-item-title">
                <img src="../../assets/img/index/solutionr5.png" alt="" class="solution-item-logo solution5">
                <span class="solution-item-name">病虫害监测</span>
              </div>
              <p class="solution-item-description">分类统计及时上报病虫害数据，对区域虫情进行数据分析，实现农户对害虫进行更精准的防控和治理。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 工业app -->
    <div class="industryApp-modular-container">
      <div class="center-container">
        <div class="industryApp-info-container">
          <div class="industryApp-describe-container">
            <p class="industryApp-first-title">农业农村移动端</p>
            <p class="industryApp-sub-title">乡村振兴，数字化乡镇综合应用服务类应用产品</p>
          </div>
          <img src="../../assets/img/index/gongye_bg.png" alt="" class="right-bg">
          <!-- <a href="javascript:;" class="see-more-btn" @click="jump( 'softwareList' )">查看更多</a> -->
        </div>
        <div class="industryApp-example-container">
          <div class="industryApp-three-column-container">
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'shuzixiangcun' )">
              <img src="../../assets/img/index/app_default_img1.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">数字乡村</p>
              <p class="item-example-subTitle" v-if="shownav">公共卫生、村务党政、生活广场、农产品电商全面推进 新农村数字化建设</p>
              <p class="item-example-subTitle" v-else>公共卫生、生活广场、农产品电商全面推进 新农村数字化建设</p>
            </div>
            <div class="industryApp-item-example-container industryApp-three-item-example-container">
              <img src="../../assets/img/index/app_default_img8.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">垃圾分类</p>
              <p class="item-example-subTitle">垃圾分类，垃圾满溢实时查询，站点清运状态，村民自治，共同监督</p>
            </div>
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'allShareAac' )">
              <img src="../../assets/img/index/app_default_img9.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">共享田园</p>
              <p class="item-example-subTitle">助力乡村振兴，打造田园共享经济，吸引游客旅游，促销乡村特产</p>
            </div>
            <!--  -->

            <!-- <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'digitalFishery' )">
              <img src="../../assets/img/index/app_default_img3.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">数字渔场</p>
              <p class="item-example-subTitle">提供养殖基地管理、养殖物资采购、物联网设备管理</p>
            </div> -->
          </div>
          <div class="industryApp-three-column-container" v-if="shownav"> 
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'newPeople' )">
              <img src="../../assets/img/index/app_default_img10.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">新农人</p>
              <p class="item-example-subTitle">农村专业招工，农民工找工作平台，农村岗位技能培训人才培训管理，乡村人才引进线上渠道</p>
            </div>
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'online_retailers' )">
              <img src="../../assets/img/index/app_default_img2.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">农村电商邻里拼</p>
              <p class="item-example-subTitle">拼团买菜更多实惠，贴近乡村生活的买菜小程序</p>
            </div>
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'farmingandagriculturalmaterials' )">
              <img src="../../assets/img/index/app_default_img4.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">农事农资</p>
              <p class="item-example-subTitle">投入品管理、农事排期、田间作业管理、农机管理</p>
            </div>
            <!-- <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'farmingandagriculturalmaterials' )">
              <img src="../../assets/img/index/app_default_img4.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">农事农资</p>
              <p class="item-example-subTitle">投入品管理、农事排期、田间作业管理、农机管理</p>
            </div> -->
           
          </div>
          <div class="industryApp-three-column-container" v-if="shownav"> 
              <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'zhihui2.5' )">
              <img src="../../assets/img/index/app_default_img11.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">数字农业</p>
              <p class="item-example-subTitle">农作物生长模型，生长数据实时监测，人工智能大数据分析，智能决策，远程调控农作物最佳生长环境</p>
            </div>
             <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'smartpensionsolutions' )">
              <img src="../../assets/img/index/app_default_img5.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">智慧养老</p>
              <p class="item-example-subTitle">随身监护、健康管理、远程医疗、一键呼救</p>
            </div>
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'nongyesuyuan' )">
              <img src="../../assets/img/index/app_default_img6.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">农产品溯源</p>
              <p class="item-example-subTitle">物联网信息采集，追溯农产品育苗到生产加工质检销售等全过程信息</p>
            </div>
          </div>
           <div class="industryApp-three-column-container" v-else> 
            
           
            <div class="industryApp-item-example-container industryApp-three-item-example-container" @click="jump( 'nongyesuyuan' )" style="width:50%">
              <img src="../../assets/img/index/app_default_img6.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">农产品溯源</p>
              <p class="item-example-subTitle">物联网信息采集，追溯农产品育苗到生产加工质检销售等全过程信息</p>
            </div>
          </div>
          <!-- <div class="industryApp-two-column-container">
            <div class="industryApp-item-example-container industryApp-two-item-example-container" @click="jump( 'intelligentWorkOrderERP' )">
              <img src="../../assets/img/index/app_default_img4.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">智能工单ERP</p>
              <p class="item-example-subTitle">面向进销存、库位管理、生产工序、测试工序、售后三包工序管理</p>
            </div>
            <div class="industryApp-item-example-container industryApp-two-item-example-container" @click="jump( 'beautiful' )">
              <img src="../../assets/img/index/app_default_img5.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">仪器仪表售后跟踪</p>
              <p class="item-example-subTitle">在线监测、培训维修、售后工单</p>
            </div>
          </div>
          <div class="industryApp-two-column-container">
            <div class="industryApp-item-example-container industryApp-two-item-example-container" @click="jump( 'gongye_oa' )">
              <img src="../../assets/img/index/app_default_img6.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">工业OA</p>
              <p class="item-example-subTitle">多级分派订单任务，实时跟踪任务进度</p>
            </div>
            <div class="industryApp-item-example-container industryApp-two-item-example-container" @click="jump2">
              <img src="../../assets/img/index/app_default_img7.png" alt="" class="item-example-img">
              <p class="item-example-firstTitle">更多</p>
              <p class="item-example-subTitle"></p>
            </div>
          </div> -->
        </div>
      </div>
    </div>

        <!-- 全厂物联平台 -->
    <div class="whole-house-iot-platform-modular-container">
      <div class="center-container">
        <!-- 模块信息 -->
        <div class="platform-info-container">
          <!-- 平台介绍 -->
          <div class="platform-left-description-container" style="position:relative">
            <p class="platform-name">百倍云物联操作系统</p>
            <p class="platform-details">
             以加速农业农村现代化发展和转型进程，既是乡村振兴的战略方向，也是建设数字中国的重要内容。百倍云打造了物联网闭环数据服务生态圈IOT平台，面向传感器的物联操作系统，多传感多协议快速配置标准流程接入技术研究和产业化，拼图式硬件集成，装配式物联方案搭积木式快速扩展应用，快速省成本建设物联网工程，减少为智能互联产品创建新型应用程序所需的时间、成本和风险，助力现代化乡村数字化建设
            </p>
            <img src="../../assets/img/index/zt5.png" alt="" style="position:absolute;bottom:0;right:0">
            <a href="javascript:;" class="see-more-btn" @click="jump( 'bby_iot_platform' )">
              查看更多
            </a>
          </div>
          <!-- 特点 优点描述 -->
          <div class="platform-rigth-characteristics-container">
            <div>
              <div class="platform-item-characteristics-container" @click="jump( 'bby_iot_platform' )">
                <img src="../../assets/img/index/zt1.png" alt="" class="characteristics-logo">
                <p class="characteristics-title"></p>
                <p class="characteristics-description">
                  "严选180余种传感器，快速配置接入，系统满足中长期稳定性设计"：完全可以在无需开发代码情况下，接入我们的传感器和网关设接入我们的传感器和网关设备，同时也支持任何开放协议的第三方厂家设备。
                </p>
              </div>
              <div class="platform-item-characteristics-container" @click="jump( 'bby_iot_platform' )">
                <img src="../../assets/img/index/zt2.png" alt="" class="characteristics-logo">
                <p class="characteristics-title"></p>
                <p class="characteristics-description">
                  通过配置流程向导支持的协议种类达15种（TCP、UDP私有协议，MODBUS协议、OPC协议，212油烟监测协议，101/102电表规约，MQTT协议，SNMP协议等）。
                </p>
              </div>
            </div>
            <div>
              <div class="platform-item-characteristics-container" @click="jump( 'bby_iot_platform' )">
                <img src="../../assets/img/index/zt3.png" alt="" class="characteristics-logo">
                <p class="characteristics-title"></p>
                <p class="characteristics-description">
                  成本更低，集成度更高，更专业，软硬件结合，软件子系统丰富复用，包含大田、大棚渔场、环境监测、农产品溯源等。
                </p>
              </div>
              <div class="platform-item-characteristics-container" @click="jump( 'bby_iot_platform' )">
                <img src="../../assets/img/index/zt4.png" alt="" class="characteristics-logo">
                <p class="characteristics-title"></p>
                <p class="characteristics-description">
                  多种套餐 120种设备互联套餐 覆盖wifi，lora 4G，5G，有线通信和边缘计算和云计算选型。
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 平台功能 -->
        <div class="platform-ability-container">
          <div class="platform-item-ability-container" @click="jump( 'bby_iot_platform' )">
            <img src="../../assets/img/index/ability1.png" alt="" class="ability-logo-container">
            <div class="ability-description-container">
              <p class="ability-title">多协议多设备多方式连接</p>
              <p class="ability-sub-title">一个万物互联的实物系统</p>
            </div>
          </div>
          <div class="platform-item-ability-container" @click="jump( 'bby_iot_platform' )">
            <img src="../../assets/img/index/ability2.png" alt="" class="ability-logo-container">
            <div class="ability-description-container">
              <p class="ability-title">多终端数据显示</p>
              <p class="ability-sub-title">高性能数据库</p>
            </div>
          </div>
          <div class="platform-item-ability-container" @click="jump( 'bby_iot_platform' )">
            <img src="../../assets/img/index/ability3.png" alt="" class="ability-logo-container">
            <div class="ability-description-container">
              <p class="ability-title">人工智能算法</p>
              <p class="ability-sub-title">智慧农业模型集合</p>
            </div>
          </div>
        </div>
      </div>
    </div>
        <!-- 产品模块 -->
    <div class="product-modular-container" style="padding-top:10px;background:#eee">
      <div class="center-container">
        <div class="modular-title-container">
          <p class="modular-first-title">丰富可靠的智能产品</p>
          <p class="modular-sub-title">高效稳定的智能农业服务硬件产品</p>
        </div>
        <div class="product-exhibition-container">
          <!-- <ul class="product-list-container">
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
          </ul>
          <ul class="product-list-container">
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
          </ul>
          <ul class="product-list-container">
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' )">
                <span class="product-name">
                  开关量模拟器、采集器
                </span>
                <img src="../../assets/img/index/device1.png" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link see-more" @click="jump( 'hardwareList' )">
                <span class="product-name">
                  查看更多
                </span>
                <img src="../../assets/img/common/chakangengduo.png" alt="" class="product-img">
              </a>
            </li>
          </ul> -->
          <ul class="product-list-container">
            <li class="product-item-container" v-for="( item , key ) in hardwareList" :key="key">
              <a href="javascript:;" class="product-link" @click="jump( 'hardwareDetails' , item.id )">
                <span class="product-name">
                  {{ item.title }}
                </span>
                <img :src="item.image" alt="" class="product-img">
              </a>
            </li>
            <li class="product-item-container">
              <a href="javascript:;" class="product-link see-more" @click="jump( 'hardwareList' )">
                <span class="product-name">
                  查看更多
                </span>
                <img src="../../assets/img/common/chakangengduo.png" alt="" class="product-img">
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
     <div class="customer-modular-container">
      <div class="center-container">
        <p class="solution-first-title" style="margin-bottom:40px">部分案例</p>
        <img src="../../assets/img/index/al7.png" alt="" style="margin:auto;margin-bottom:10px;margin-top:35px;margin-bottom:30px">
        <img src="../../assets/img/index/al1.png" alt="" style="margin:auto;margin-bottom:10px">
        <img src="../../assets/img/index/al2.png" alt="" style="margin:auto;margin-bottom:10px">
        <img src="../../assets/img/index/al3.png" alt="" style="margin:auto;margin-bottom:10px">
        <img src="../../assets/img/index/al4.png" alt="" style="margin:auto;margin-bottom:10px">
        
        <!-- <img src="../../assets/img/index/al6.png" alt="" style="margin:auto;margin-bottom:10px"> -->
      </div>
    </div>
    
    <!-- 智造社区 -->
     <img src="../../assets/img/index/bwcx.png" alt="" class="solution-item-logo solution5" style="width:100%">
    <div class="intelligent-Creation-modular-container">
      <div class="center-container">
        <!-- 标题 -->
        <div class="modular-title-container">
          <p class="modular-first-title">数字乡村社区</p>
          <p class="modular-sub-title">连接百万开发者与技术专家学习、交流、分享的互动平台，致力为打造数字化乡村添砖加瓦，欢迎您的加入</p>
        </div>
        <!-- 内容 -->
        <div class="modular-content-container">
          <div class="modular-content-top-container">
            <div class="content-left-container">
              <a href="http://www.乡村互联.com/forum" target="_blank">
                <!-- <img :src="choiceArticleList[0].image" alt=""> -->
              </a>
            </div>
            <div class="content-center-container">
              <p class="content-title-container">热门产品</p>
              <ul class="content-list-container">
                <li class="content-item-container" @click="jump( 'hardwareDetails' , item.id )" v-for="( item , index ) in HaveGoodsReviewList" :key="index">
                  <a href="javascript:;" class="labelType labelTypeBgColor1">测评</a>
                  <a href="javascript:;" class="item-img">
                    <img :src="item.image" alt="">
                  </a>
                </li>
                <!-- <li class="content-item-container">
                  <a href="javascript:;" class="labelType labelTypeBgColor1">测评</a>
                  <a href="javascript:;" class="item-img">
                    <img src="../../assets/img/index/remen_product2.png" alt="">
                  </a>
                </li>
                <li class="content-item-container">
                  <a href="javascript:;" class="labelType labelTypeBgColor1">测评</a>
                  <a href="javascript:;" class="item-img">
                    <img src="../../assets/img/index/remen_product3.png" alt="">
                  </a>
                </li> -->
              </ul>
            </div>
            <div class="content-right-container">
              <p class="content-title-container">精华文章</p>
              <ul class="content-list-container">
                <li class="content-item-container" :data-id=" item.objectId " v-for="(item, index) in choiceArticleList" :key="index">
                  <div class="labelType-container">
                    <a href="javascript:;" class="labelType labelTypeBgColor1">严选测评</a>
                    <a href="javascript:;" class="labelType labelTypeBgColor2">分类报告</a>
                  </div>
                  <div class="content-all-container">
                    <a :href="'http://www.乡村互联.com/forum/view/article_details.html?article='+ item.objectId +'&isFeatured=1'" target="_blank">
                      <p class="item-title-container">{{ item.title }}</p>
                      <p class="item-content-container">{{ item.content }}</p>
                    </a>
                  </div>
                </li>
                <!-- <li class="content-item-container">
                  <div class="labelType-container">
                    <a href="javascript:;" class="labelType labelTypeBgColor1">严选测评</a>
                    <a href="javascript:;" class="labelType labelTypeBgColor2">分类报告</a>
                  </div>
                  <div class="content-all-container">
                    <a href="javascript:;">
                      <p class="item-title-container">使用 FastAI 和即时频率变换进行音频分类</p>
                      <p class="item-content-container">目前深度学习模型能处理许多个不同类型的问题，对于一些教程或框架用图像教程或框架用图像...</p>
                    </a>
                  </div>
                </li>
                <li class="content-item-container">
                  <div class="labelType-container">
                    <a href="javascript:;" class="labelType labelTypeBgColor1">严选测评</a>
                    <a href="javascript:;" class="labelType labelTypeBgColor2">分类报告</a>
                  </div>
                  <div class="content-all-container">
                    <a href="javascript:;">
                      <p class="item-title-container">强化学习(十六) 深度确定性策略梯度(DDPG)</p>
                      <p class="item-content-container">从DDPG这个名字看，它是由D（Deep）+D（Deterministic ）+ PG(Policy Gradient)组成。PG(Policy Gradient)...</p>
                    </a>
                  </div>
                </li>
                <li class="content-item-container">
                  <div class="labelType-container">
                    <a href="javascript:;" class="labelType labelTypeBgColor1">严选测评</a>
                    <a href="javascript:;" class="labelType labelTypeBgColor2">分类报告</a>
                  </div>
                  <div class="content-all-container">
                    <a href="javascript:;">
                      <p class="item-title-container">IOT，亿万狂想曲</p>
                      <p class="item-content-container">只是这个未来太过遥远，以至于在过去数年，听众已经厌烦了这样的想象，对物联网的注意力...</p>
                    </a>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
          <div class="modular-content-bottom-container">
            <!-- 活动结构 -->
            <div class="modular-content-item-container modular-activity-container">
              <a href="javascript:;" class="contentLabelType labelType-activity">精彩活动</a>
              <div class="content-item-info-container">
                <p class="content-item-info-title-container">{{ jxActivity.title }}</p>
                <p class="content-item-info-lecturer-container">
                  <span>主讲人：</span><span>{{ jxActivity.activitySpeaker }}</span>
                </p>
              </div>
              <div class="partake-activity-container">
                <p class="partake-address-container">
                  <span>地点：</span><span>{{ jxActivity.detailedAddress }}</span>
                </p>
                <p class="partake-link-container">
                  <a :href="'http://www.乡村互联.com/forum/view/salon_details.html?id='+ jxActivity.id +''" target="_blank">马上报名</a>
                </p>
              </div>
            </div>
            <!-- 大赛 -->
            <div class="modular-content-item-container modular-match-container">
              <a href="javascript:;" class="contentLabelType labelType-match">科技大赛</a>
              <a :href="'http://www.乡村互联.com/forum/view/salon_details.html?id='+ dsActivity.id +''" class="content-item-info-container" target="_blank">
                <img :src="dsActivity.image" alt="" class="info-logo">
                <div class="match-info-container">
                  <p class="content-item-info-title-container">{{ dsActivity.title }}</p>
                  <p class="match-time">{{ dsActivity.startTime }}</p>
                </div>
              </a>
              <div class="partake-activity-container">
                <p class="partake-address-container">
                  <span>{{ dsActivity.detailedAddress }}</span>
                </p>
              </div>
            </div>
            <div class="modular-content-item-container modular-activity-container modular-course-container">
              <a href="javascript:;" class="contentLabelType labelType-course">热门课堂</a>
              <div class="content-item-info-container">
                <p class="content-item-info-title-container">{{ remenJT.groupName }}</p>
              </div>
              <div class="partake-activity-container">
                <p class="classHour-container">
                  <span class="classHour-text">{{ remenJT.groupNum }}</span><span>课时</span>
                </p>
                <p class="partake-link-container">
                  <a :href="'http://www.乡村互联.com/forum/view/jiangtang_details.html?id='+ remenJT.id +''" target="_blank">马上报名</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻 -->
    <div class="customer-modular-container">
      <div class="center-container">
        <p class="solution-first-title" style="margin-bottom:40px">新闻动态</p>
        <!-- <div @click="jump('newslist')" style="position: absolute;cursor:pointer;
    top: 80px;
    right: 39px;
    font-size: 18px;
    color: #111;">查看更多<font style="    color: #34A151;
    margin-left: 7px;">>></font></div> -->

          <div class="news-box">
            <div class="platform-item-ability-container" v-for="( item , key ) in newslist" :key="key" >
              <img :src="item.image" alt="" class="ability-logo-container" style="height:252px">
              <div class="ability-description-container">
                <p class="ability-sub-title" style="font-size:14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.title}}</p>
              </div>
            </div>
            <!-- <div class="platform-item-ability-container" >
              <img src="../../assets/img/index/new1.png" alt="" class="ability-logo-container">
              <div class="ability-description-container">
                <p class="ability-sub-title">热烈欢迎济南市委领导来百倍云参观考察</p>
              </div>
            </div>
            <div class="platform-item-ability-container" >
              <img src="../../assets/img/index/new2.png" alt="" class="ability-logo-container">
              <div class="ability-description-container">
                <p class="ability-sub-title">热烈欢迎台州市委领导来百倍云参观考察</p>
              </div>
            </div>
            <div class="platform-item-ability-container" >
              <img src="../../assets/img/index/new3.png" alt="" class="ability-logo-container">
              <div class="ability-description-container">
                <p class="ability-sub-title">百倍云受邀参展2020长沙网络安全·智能制造展</p>
              </div>
            </div>
                <div class="platform-item-ability-container">
              <img src="../../assets/img/index/new4.png" alt="" class="ability-logo-container">
              <div class="ability-description-container">
                <p class="ability-sub-title">金华开发区委领导莅临考察交流</p>
              </div>
            </div>
                <div class="platform-item-ability-container" >
              <img src="../../assets/img/index/new5.png" alt="" class="ability-logo-container">
              <div class="ability-description-container">
                <p class="ability-sub-title">热烈欢迎遂昌县农业局领导参观考察</p>
                  </div>
            </div>
                <div class="platform-item-ability-container">
              <img src="../../assets/img/index/new6.png" alt="" class="ability-logo-container">
              <div class="ability-description-container">
                <p class="ability-sub-title">中科院细胞生物学会科学家论坛交流展示厅建设</p>
              </div> 
            </div> -->
          </div>
      </div>
    </div>
    <!-- 客户 -->
    <div class="customer-modular-container">
      <div class="center-container">
        <p class="solution-first-title">我们的客户</p>
        <p class="solution-sub-title">共建万物互联的智能时代</p>
        <div class="customer-item-container logo-rigth hua">
          <p class="solution-first-title">遂昌人民政府 农业部主任</p>
          <p class="solution-sub-title">
            <span>百倍云智慧农业项目贴近农业生产实际，产品能够在控制成本的基础上效益最大化，值得推荐！</span>
            <a href="javascript:;" class="contentLabelType labelType-activity" @click="jump( 'intelligentAgriculture' )">查看详情</a>
          </p>
          <img src="../../assets/img/index/supor_logo.png" alt="" class="customer-logo">
        </div>
        <div class="customer-item-container logo-left kaineng">
          <p class="solution-first-title">中科院未米示范基地 项目主管</p>
          <p class="solution-sub-title">
            <span>我们选择了百倍云，事实证明我们的选择是正确的，软硬件结合很到位，设备很好用！</span>
            <a href="javascript:;" class="contentLabelType labelType-activity" @click="jump( 'intelligentAgricultureall' )">查看详情</a>
          </p>
          <img src="../../assets/img/index/chnt_logo.png" alt="" class="customer-logo">
        </div>
        <div class="customer-item-container logo-rigth jili">
          <p class="solution-first-title">立新有机番茄农场 生产主管</p>
          <p class="solution-sub-title">
            <span>对比多家供应商后，我们选择了百倍云，事实证明我们的选择是正确的，产能得到了大幅度提升！</span>
            <a href="javascript:;" class="contentLabelType labelType-activity" @click="jump( 'intelligentAgriculturexample' )">查看详情</a>
          </p>
          <img src="../../assets/img/index/mingyue_logo.png" alt="" class="customer-logo">
        </div>
        <p class="solution-first-title">目前已成功与数十家政府及规模企业达成合作</p>
        <ul class="other-customer-list-container">
          <li class="other-customer-item-container lan">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy1.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container fen">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy2.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container lan">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy3.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container fen">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy4.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container fen">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy5.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container lan">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy6.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container fen">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy7.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container lan">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy8.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container lan">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy9.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container fen">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy10.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container lan">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy11.png" alt="">
            </a>
          </li>
          <li class="other-customer-item-container fen">
            <a href="javascript:;">
              <img src="../../assets/img/index/qy12.png" style="width:90%;margin:auto" alt="">
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 加入我们 -->
    <div class="join-us-modular-container">
      <div class="center-container">
        <p class="solution-first-title">加入我们</p>
        <p class="solution-sub-title">此时此刻，非你莫属</p>
        <i class="bottom-line"></i>
        <div class="join-container">
          <div class="team-info-container">
            <div class="card-label-container">
              <p class="solution-first-title">精英团队</p>
              <p class="solution-sub-title">Our New March Your Novel Match</p>
            </div>
            <div class="card-content-container">
              <div class="card-item-content-container">
                <img src="../../assets/img/common/teamMember1.webp" alt="" class="card-content-logo">
                <div class="card-info-container">
                  <p>
                    <span class="fullName">高炎 / </span>
                    <span class="position">总经理</span>
                  </p>
                  <p class="card-describe">
                    任职浙大成果转化中心数字农业团队负责人、浙江大学物联网网络国家重点实验室、创业路上"中年大叔"10年+ 技术+产品+运营...
                  </p>
                </div>
              </div>
              <div class="card-item-content-container">
                <img src="../../assets/img/common/teamMember2.webp" alt="" class="card-content-logo">
                <div class="card-info-container">
                  <p>
                    <span class="fullName">孙中赛 / </span>
                    <span class="position">产品总监</span>
                  </p>
                  <p class="card-describe">
                    负责公司数据中台架构、核心产品线策略制定、实施及产品生命周期管理、确认产品路线图、产品调研、产品策划、产品发布...
                  </p>
                </div>
              </div>
              <div class="card-item-content-container">
                <img src="../../assets/img/common/teamMember3.webp" alt="" class="card-content-logo" style=" width: 96px; height: auto; position: relative; top: -6px; left: -8px;">
                <div class="card-info-container">
                  <p>
                    <span class="fullName">龙迎春 / </span>
                    <span class="position">浙大研究院智能互联专家</span>
                  </p>
                  <p class="card-describe">
                    任职浙江大学技术研究院物联通信部、数字乡村实验室带头人、硬件开发工程师及测试技术团队负责人、10年+ 技术+产品...
                  </p>
                </div>
              </div>
              <div class="card-item-content-container">
                <img src="../../assets/img/common/teamMember5.png" alt="" class="card-content-logo" style=" width: 96px; height: auto; position: relative; top: -18px; left: -8px;">
                <div class="card-info-container">
                  <p>
                    <span class="fullName">娄李伟 / </span>
                    <span class="position"> 浙江农业科学院专家</span>
                  </p>
                  <p class="card-describe">
                   中国数字乡村发展创新联盟专家委员会委员 理事
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="recruit-info-container">
            <div class="card-label-container">
              <p class="solution-first-title">此时此刻 非你莫属</p>
              <p class="solution-sub-title">Our New March Your Novel Match</p>
            </div>
            <div class="card-content-container">
              <ul class="recruit-job-list-container">
                <li class="recruit-job-item-container">
                  <a href="javascript:;" @click="jump( 'positionList' ,  '0' )">
                    <p class="recruit-job-name">Java工程师</p>
                    <p class="recruit-job-info">
                      <span>工作地点：杭州市 / 招聘人数：3人</span>
                      <img src="../../assets/img/index/youjiantou.png" alt="" class="youjiantou">
                    </p>
                  </a>
                </li>
                <li class="recruit-job-item-container">
                  <a href="javascript:;" @click="jump( 'positionList' ,  1 )">
                    <p class="recruit-job-name">自动化工程师</p>
                    <p class="recruit-job-info">
                      <span>工作地点：常州市 / 招聘人数：2人</span>
                      <img src="../../assets/img/index/youjiantou.png" alt="" class="youjiantou">
                    </p>
                  </a>
                </li>
                <li class="recruit-job-item-container">
                  <a href="javascript:;" @click="jump( 'positionList' ,  3 )">
                    <p class="recruit-job-name">高级运营总监</p>
                    <p class="recruit-job-info">
                      <span>工作地点：杭州市 / 招聘人数：1人</span>
                      <img src="../../assets/img/index/youjiantou.png" alt="" class="youjiantou">
                    </p>
                  </a>
                </li>
                 <li class="recruit-job-item-container">
                  <a href="javascript:;" @click="jump( 'positionList' ,  3 )">
                    <p class="recruit-job-name">WEB前端开发工程师</p>
                    <p class="recruit-job-info">
                      <span>工作地点：杭州市 / 招聘人数：1人</span>
                      <img src="../../assets/img/index/youjiantou.png" alt="" class="youjiantou">
                    </p>
                  </a>
                </li>
              </ul>
              <a class="see-more" href="javascript:;" @click="jump( 'positionList' )">查看更多</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'
import axios from 'axios'
export default {
  name: 'index',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
       newslist:[],
      shownav:false,
      // banner_img: require('../../assets/img/index/banner1.png'),
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        loop : true,
        initialSlide: 0, // 默认显示第几个
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination',
          bulletElement : 'li',
          bulletClass : 'my-bullet',//需设置.my-bullet样式
          bulletActiveClass: 'my-bullet-active',
          clickable :true,
        },
      },
      pageNum: 1, // 页数
      pageSize: 14, // 条数
      keyWord: '', // 搜索关键字
      dataType: '', // 商品类型
      hardwareList: [], // 硬件列表数据
      choiceArticleList: [], // 精选文章列表
      remenJT: [], // 热门讲堂
      jxActivity: [], // 精选活动
      dsActivity: [], // 活动大赛
      HaveGoodsReviewList: [], // 测评产品
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created () {
    
    this.init()
  },
  mounted() {
    this.changetitle()
    
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
  },
  methods: {
    init(){
      this.getGoodsInfoList();
      this.listArticleBySortNum();
      this.getRecommendActivityVideo();
      this.getListActivityMiniByCondition();
      // this.getListActivityMiniByConditionCopy();
      this.getHaveGoodsReviewList();
    },
    changetitle(){//http://www.100byun.com  http://100byun.com使用这个域名访问官网时，底部的备案信息需要更换下，其它访问方式时，底部备案信息还是跟当前一样不变
        var url = window.location.href
        this.shownav = true
        if(url.split("/#/")[0] == "http://www.100byun.com"||url.split("/#/")[0] == "http://100byun.com"){
          this.getnewsList("http://www.100byun.com/number_countryside_webservice")
        }else{
          this.getnewsList("http://www.乡村互联.com/number_countryside_webservice")
          
      }
    },
    jump( pathName , id ){
      if( id ){
        this.$router.push({
          name: pathName,
          query: {
            id: id,
          }
        })
      }else{
        this.$router.push({
          name: pathName,
        })
      }
    },
    jump2(){
      window.location.href = "http://www.bbyiot.com/app/"
    },
    callback(){},
    slideTo( index ){
      this.swiper.slideTo( index, 500, false) // 控制Swiper切换到指定slide。
    },
    getnewsList(url){ // 获取新闻列表
      axios.get(url+'/app-api/sysNews/getSysNewsList', 
        {
          params: {
            type:0,
            pageNum: 1,
            pageSize: 100,
          },
        }).then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data.data
          this.newslist = data
        }
      })
     },
    listArticleBySortNum(){ // 获取精选文章
      axios.get('http://115.29.203.1:8045/robot3' + "/web/articleInfo/listArticleBySortNum?&pageNum=" + 1 + "&pageSize=" + 3 + "&dataType=" + 2 + "&specialType=" + 1, 
        {
          params: {
            pageNum: 1,
            pageSize: 3,
            dataType: 2,
            specialType: 1, // 文章类型 1 ： 测评文章 ， 0 ： 其他文章
            token: '',
          },
        }).then( ( res ) =>{
          if( res.code === 200 ){
            let data = res.data

            let list = data.list
            for( let i = 0 , len = list.length ; i < len ; i++ ){

              let str = list[i].content

              if( str.length > 42 ){
                list[i].content = str.substr( 0 , 42 )
              }
            }
            this.choiceArticleList = data.list
          }
        }).catch( ( err ) =>{
          console.log( err );
        })
    },
    getRecommendActivityVideo(){ // 获取热门课堂
      axios.get('http://115.29.203.1:8045/robot3' + "/web/activityVideo/getRecommendActivityVideo", 
        {}).then( ( res ) =>{
          if( res.code === 200 ){
            let data = res.data
            this.remenJT = data[0]
          }
        }).catch( ( err ) =>{
          console.log( err );
        })
    },
    getListActivityMiniByCondition(){ // 获取活动
      axios.get('http://115.29.203.1:8045/robot3' + "/web/activityMini/getListActivityMiniByCondition", 
        {
         params: {
            pageNum: 1,
            pageSize: 1,
            token: '',
            dataType: 1, // 精选
             activityType: 0, // 大赛
            city: '',
            activityMode: '',
            activityClassifyId: '',
            startTime: ''
          }
        }).then( ( res ) =>{
          if( res.code === 200 ){
            let data = res.data
            let list = data.list
            this.jxActivity = list.length ? list[0] : {}
          }
          this.getListActivityMiniByConditionCopy()
        }).catch( ( err ) =>{
          console.log( err );
        this.getListActivityMiniByConditionCopy()
        })
    },
    getListActivityMiniByConditionCopy(){ // 获取活动( 大赛 )
      axios.get('http://115.29.203.1:8045/robot3' + "/web/activityMini/getListActivityMiniByCondition", 
        {
         params: {
            pageNum: 1,
            pageSize: 1,
            token: '',
            dataType: 1, // 精选
            activityType: 1, // 大赛
            city: '',
            activityMode: '',
            activityClassifyId: '',
            startTime: ''
          }
        }).then( ( res ) =>{
          if( res.code === 200 ){
            let data = res.data
            let list = data.list
            this.dsActivity = list.length ? list[0] : {}
          }
        }).catch( ( err ) =>{
          console.log( err );
        })
    },
    getHaveGoodsReviewList(){ // 获取最新测评信息的产品
      this.$api.hardware.getHaveGoodsReviewList(
        1, // 页码
        3, // 条数
      ).then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data
          this.HaveGoodsReviewList = data
        }
      })
    },
    getGoodsInfoList(){ // 获取商品列表
      this.$api.hardware.getGoodsInfoList(
        this.keyWord,
        this.pageNum,
        this.pageSize,
        this.dataType,
      ).then( ( res ) =>{
        if( res.code == 200 ){
          let data = res.data
          this.hardwareList = data
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
